import { Component, OnInit, ViewChild, ViewEncapsulation, Input} from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import {MatTableDataSource} from '@angular/material/table';
import {BeanPlanoDeAcao} from 'src/bean/BeanPlanoDeAcao';
import {BeanSlideOperacao} from '../../../bean/BeanSlideOperacao';
import {MatSort} from '@angular/material/sort';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import { ParecerPlanoDeAcaoService } from './parecer-plano-acao.service';
import {MatSlideToggleChange} from '@angular/material/slide-toggle';
import { BeanOperacao } from 'src/bean/BeanOperacao';
import { BeanTipoUsuario } from 'src/bean/BeanTipoUsuario';
import { BeanSituacao } from 'src/bean/BeanSituacao';
import { BeanUsuarioPorOperacao } from 'src/bean/BeanUsuarioPorOperacao';
import { BeanMenu } from 'src/bean/BeanMenu';
import { BeanSlideMenu } from 'src/bean/BeanSlideMenu';
import { BeanUsuarioPorMenu } from 'src/bean/BeanUsuarioPorMenu';

import { ConfirmationDialogComponent } from 'src/app/shared/components/confirmation-dialog/confirmation-dialog.component';





import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { AddAlertTwoTone, LeakRemoveTwoTone } from '@material-ui/icons';
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';

import { AESEncryptDecryptService } from "../../AESEncryptDecryptService";
import { EmpresaUsuarioDialog, PermissaoUsuarioDialog } from '../cadastro-usuario/cadastro-usuario.component';
import { CadastroUsuarioService } from '../cadastro-usuario/cadastro-usuario.service';
import { BeanStatusPlanoAcao } from 'src/bean/BeanStatusPlanoAcao';
import { BeanMes } from 'src/bean/BeanMes';
import { BeanParecer } from 'src/bean/BeanParecer';
import { BeanUsuario } from 'src/bean/BeanUsuario';
import { Observable, ReplaySubject, Subscription } from 'rxjs';
import { BeanMonitoria } from 'src/bean/BeanMonitoria';
import { MonitoriaService } from '../monitoria/monitoria.service';
import { BeanActionPlanFiles } from 'src/bean/BeanActionPlanFiles';
import { AnexosDialogComponent } from '../monitoria/anexos-dialog/anexos-dialog.component';




@Component({
  selector: 'app-parecer-plano-acao',
  templateUrl: './parecer-plano-acao.component.html',
  styleUrls: ['./parecer-plano-acao.component.css']
})
export class ParecerPlanoAcaoComponent implements OnInit {


  @Input()
  requiredFileType:string;
  fileName = '';
  uploadProgress:number;
  uploadSub: Subscription;
  public file:File = null;  
  public beanActionPlanFiles : BeanActionPlanFiles = new BeanActionPlanFiles(null, null, null, null, null);
  public beanMonitoria :  BeanMonitoria = new BeanMonitoria(null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null, [], [], null, [], [],null,null);
  public base64Output : string;
  public contemAnexo: Boolean = false;
  public qtdAnexos: number = 0;

  public isFinalizado: Boolean = false;


  @ViewChild(MatSort) sort: MatSort;
  //displayedColumns: string[] = ['placDsAcao', 'placDhCadastro', 'placDhDataacao', 'datafinalacao', 'percentual'];
  displayedColumns: string[] = ['placIdCdPlanoacao', 'placDsAcao',  'placDhDataacao', 'datafinalacao', 'statusPlanoAcao', 'excluir'];
  displayedColumnsParecer: string[] = ['operations', 'month', 'pareNrAno', 'pareDhInativo'];
  
  

  public lstPlanosDeAcoes: BeanPlanoDeAcao[] = []
  public lstParecer: BeanParecer[] = []  
  public lstCmbOperacao: BeanOperacao[];
  public lstCmbSituacao: BeanSituacao[];
  //public lstCmbTipoUsuario: BeanTipoUsuario[];
  public lstCmbStatusPlanoAcao: BeanStatusPlanoAcao[];
  public lstCmbMesParecer: BeanMes[];
  idUser : string = this._AESEncryptDecryptService.decrypt(localStorage.getItem('idUser').trim());
  
  public sessionExpired: boolean = false;


  dataSource = new MatTableDataSource<BeanPlanoDeAcao>(this.lstPlanosDeAcoes);
  dataSourceParecer = new MatTableDataSource<BeanParecer>(this.lstParecer);

  selectedIndex: number = 0;
  formControlDesligado = new FormControl('', []);
  planoDeAcaoBean : BeanPlanoDeAcao;
  parecerBean : BeanParecer;
  situacaoBean : BeanSituacao;
  operacaoBean : BeanOperacao;
  tipoUsuarioBean : BeanTipoUsuario;
  horizontalPosition: MatSnackBarHorizontalPosition = 'right';
  verticalPosition: MatSnackBarVerticalPosition = 'top';
  yearToday : number;
   
  percentualFormulario : string;
  statusPlanoAcaoFormulario : string;
  


  constructor( public dialog: MatDialog,
              private planoDeAcaoService : ParecerPlanoDeAcaoService,
              private toastr: ToastrService,
              private _snackBar: MatSnackBar,
              private router: Router,
              private _AESEncryptDecryptService: AESEncryptDecryptService,
              private cadastroUsuarioService : CadastroUsuarioService,
              private monitoriaService : MonitoriaService
            ) { }

  ngOnInit(): void {

    this.formularioParecer.controls['pareNrAno'].setValue((new Date()).getFullYear());
    
    this.preencheCmbOperacao();
    this.listarCmbStatusPlanoAcao();
    this.listarCmbMes();
    this.listarParecer();
    

  }

 

  
  

  ngAfterContentChecked(){

    this.resetSessionExpired();
  }

  public sair() {

    this.sessionExpired = false;
    localStorage.clear();
    this.router.navigate([''])

  }

  salvarAnexo(){

    this.planoDeAcaoService.addAnexo(this.beanActionPlanFiles).then((ret: any)=>{
      this.toastr.success('Arquivo gravado com sucesso!', 'Anexar Arquivo')
      this.contemAnexo = true;
      this.beanActionPlanFiles.plaaIdCdPlanoacaoanexo = ret.planIdCdPlanoAcaoAnexo
      //fileUpload.value = ''

      this.beanActionPlanFiles = ret
    },
    errorResponse => { //CASO ERRO

      this.setSessionExpired(errorResponse);
      //this.anexoSpinner = false;

    }).catch((retorno:any) => {

      this.toastr.error(retorno.error.error_description, 'ERRO!')
      //this.anexoSpinner = false;


    });
    
  }

  instanciarArquivo(event, fileUpload) {

    this.file = event.target.files[0];

     if (this.file) {

        this.fileName = this.file.name;

        this.convertFile(this.file).subscribe(base64 => {
          this.beanActionPlanFiles.plaaDsArquivo = base64
         // this.beanActionPlanFiles.placIdCdPlanoacao = this.planoDeAcaoBean.placIdCdPlanoacao
          this.beanActionPlanFiles.plaaDsNomearquivo = this.file.name
          this.base64Output = base64;
          this.toastr.warning("Aviso, O arquivo só será salvo após salvar!");
        }, errorResponse =>{

          this.setSessionExpired(errorResponse);
        });

    }
  }
  convertFile(file : File) : Observable<string> {
    const result = new ReplaySubject<string>(1);
    const reader = new FileReader();
    reader.readAsBinaryString(file);
    reader.onload = (event) => result.next(btoa(event.target.result.toString()));
    return result;
  }


  cancelUpload() {
    this.uploadSub.unsubscribe();
    this.reset();
  }

  reset() {
    this.uploadProgress = null;
    this.uploadSub = null;
  }

  downloadAnexo(){
    //this.anexoSpinner = true
    this.planoDeAcaoService.downloadAnexo(Number(this.beanActionPlanFiles.plaaIdCdPlanoacaoanexo))
    .then((ret)=>{

      const downloadLink = document.createElement('a');


      downloadLink.href = 'data:application/octet-stream;base64,' + ret.plaaDsArquivo;
      downloadLink.download = ret.plaaDsNomearquivo;
      downloadLink.click();
      //this.anexoSpinner = false
    }, errorResponse =>{

      this.setSessionExpired(errorResponse);
    })

  }

  buscarAnexoPlanoAcao(form: BeanPlanoDeAcao){
    this.planoDeAcaoService.buscarAnexo(form.placIdCdPlanoacao)
    .then((ret) =>{
      if(ret.length > 0){
        this.qtdAnexos = ret.length
        this.contemAnexo = true
        this.fileName = ret[0].plaaDsNomearquivo
        this.beanActionPlanFiles.plaaDsNomearquivo = this.fileName;
        this.beanActionPlanFiles.plaaIdCdPlanoacaoanexo = ret[0].plaaIdCdPlanoacaoanexo
        
        this.beanActionPlanFiles.placIdCdPlanoacao = ret[0].placIdCdPlanoacao
      }

    }, errorResponse =>{

      this.setSessionExpired(errorResponse);
    })
  }

  deletarAnexo(){
    //this.anexoSpinner = true
    this.planoDeAcaoService.deletarAnexo(this.beanActionPlanFiles.plaaIdCdPlanoacaoanexo)
    .subscribe((data:any)=>{
      this.toastr.success('Arquivo excluido com sucesso!')
      //this.anexoSpinner = false
      this.contemAnexo = false
      this.fileName = ''
      this.file = null
      this.beanActionPlanFiles.plaaDsArquivo = null
      this.beanActionPlanFiles.placIdCdPlanoacao = null
      this.beanActionPlanFiles.plaaDsNomearquivo = null
    }, errorResponse => {

      this.setSessionExpired(errorResponse);
    })

  }


  public setSessionExpired(errorResponse:any) : boolean {

    if(errorResponse.status == 401){

      this.sessionExpired = true;
    }

    return this.sessionExpired;
  }

  public listarCmbStatusPlanoAcao(){


    this.planoDeAcaoService.listarStatusPlanoAcao().then((retorno:BeanStatusPlanoAcao[])=>{

      this.lstCmbStatusPlanoAcao = retorno;

    }, errorResponse => {

      this.setSessionExpired(errorResponse) ? true : this.toastr.error('Erro conexao backend\nContate o suporte.','LISTAR COMBO STATUS PLANO DE AÇÃO');

    }).catch((retorno:any) => {

      if(retorno.error.error_description.indexOf("Access token expired")>-1){
          alert("Sessão Expirada");
          this.router.navigate(['']);
        }
    });
  }


  public listarCmbMes(){

    this.planoDeAcaoService.listarMes().then((retorno:BeanMes[])=>{

      this.lstCmbMesParecer = retorno;

    }, errorResponse => {

      this.setSessionExpired(errorResponse) ? true : this.toastr.error('Erro conexao backend\nContate o suporte.','LISTAR COMBO STATUS PLANO DE AÇÃO');

    }).catch((retorno:any) => {

      if(retorno.error.error_description.indexOf("Access token expired")>-1){
          alert("Sessão Expirada");
          this.router.navigate(['']);
        }
    });
  }
  

  public resetSessionExpired(){

    if(this.sessionExpired){

			this.sair();
			this.toastr.warning("Sua sessão expirou, faça o login novamente!");
		}
  }


  @ViewChild('sortUsuario') sortUsuario = new MatSort();
  @ViewChild('sortParecer') sortParecer = new MatSort();
  


  public formularioPlanoDeAcao: FormGroup = new FormGroup({
    
    'placIdCdPlanoacao': new FormControl("", Validators.required),
    'idOperacaoMenu': new FormControl("", Validators.required),
    'placDsAcao': new FormControl("", Validators.required),
    'placdsobjetivo': new FormControl("", Validators.required),
    'placDhDataacao': new FormControl("", Validators.required),
    'placNrPrazodiasacao': new FormControl("", Validators.required),
    'placDsResponsavel': new FormControl("", Validators.required),
    'stacIdCdStatusacao': new FormControl("", Validators.required),
    'placDsAnaliseeficacia' : new FormControl(""),
    'placDsTracker' : new FormControl("", Validators.required),
    'placDsObservacao' : new FormControl(""),
    'usuaIdCdUsuario': new FormControl("", Validators.required),
    'isInativo': new FormControl("", Validators.required),

    'placDhCadastro': new FormControl(""),

    'nmUserupdate': new FormControl(""),
    'dhUpdate': new FormControl(""),
    'nmUserConcluiu': new FormControl(""),
    'dhConcluiu': new FormControl(""),
    


  })


  public formularioParecer: FormGroup = new FormGroup({
    
    'pareIdCdParecer': new FormControl("", Validators.required),
    'idOperacaoMenu': new FormControl("", Validators.required),
    'meseIdCdMeses': new FormControl("", Validators.required),
    'pareNrAno': new FormControl("", Validators.required),
    'pareTxParecer': new FormControl("", Validators.required),
    'usuaIdCdUsuario': new FormControl("", Validators.required),
    'pareDhCadastro': new FormControl("", Validators.required),
    'isInativo': new FormControl("", Validators.required),

    

  })

  public add():void{

    
    if(
        this.formularioPlanoDeAcao.get("idOperacaoMenu").value == "" ||
        this.formularioPlanoDeAcao.get("placDsAcao").value == ""    ||
         this.formularioPlanoDeAcao.get("placdsobjetivo").value == "" ||
        this.formularioPlanoDeAcao.get("placDhDataacao").value == "" ||
        this.formularioPlanoDeAcao.get("placNrPrazodiasacao").value == ""   ||
        this.formularioPlanoDeAcao.get("placDsResponsavel").value == ""   ||
        this.formularioPlanoDeAcao.get("stacIdCdStatusacao").value == ""  ||
        this.formularioPlanoDeAcao.get("placDsTracker").value == ""   
      ){
           this.toastr.error('Preencha todos os campos obrigatórios antes de salvar', 'Obrigatoriedade')
        return
      }


      if(this.formularioPlanoDeAcao.get("stacIdCdStatusacao").value == '4' && this.formularioPlanoDeAcao.get("placDsAnaliseeficacia").value == "" ){
        this.toastr.error('Ao concluir é necessário preencher Analise de efiácia', 'Obrigatoriedade')
        return
      }

     
      


      
     


      if(this.formularioPlanoDeAcao.value.placIdCdPlanoacao != '' && this.formularioPlanoDeAcao.value.placIdCdPlanoacao > 0){


        

        this.planoDeAcaoBean = new BeanPlanoDeAcao (
          this.formularioPlanoDeAcao.value.placIdCdPlanoacao,
          this.formularioPlanoDeAcao.value.idOperacaoMenu,
          this.formularioPlanoDeAcao.value.placDsAcao,
          this.formularioPlanoDeAcao.value.placdsobjetivo,
          this.formularioPlanoDeAcao.value.placDhDataacao,
          this.formularioPlanoDeAcao.value.placNrPrazodiasacao,
          this.formularioPlanoDeAcao.value.placDsResponsavel,
          this.formularioPlanoDeAcao.value.stacIdCdStatusacao,
          this.formularioPlanoDeAcao.value.placDsAnaliseeficacia,
          this.formularioPlanoDeAcao.value.placDsTracker,
          this.formularioPlanoDeAcao.value.placDsObservacao,
          this.idUser,
          this.formularioPlanoDeAcao.value.placDhCadastro,
          this.formularioPlanoDeAcao.value.placDhInativo == true ? '1900-01-01T00:00:00' : null,
          null,
          null,
          null,
          null,
          this.idUser,
          null,
          '1900-01-01T00:00:00',
          this.formularioPlanoDeAcao.value.stacIdCdStatusacao == 4 ? this.idUser : null,
          null,
          this.formularioPlanoDeAcao.value.stacIdCdStatusacao == 4 ? '1900-01-01T00:00:00' : null,
          null,
        );
        


        this.planoDeAcaoService.updatePlanoAcao(this.planoDeAcaoBean).then((retorno:any)=>{


          if(this.beanActionPlanFiles.plaaDsArquivo != "" &&
            this.beanActionPlanFiles.placIdCdPlanoacao != "" &&
            this.beanActionPlanFiles.plaaDsNomearquivo != "" &&
            this.base64Output
          ){
    
            this.beanActionPlanFiles.placIdCdPlanoacao = this.planoDeAcaoBean.placIdCdPlanoacao;
            this.salvarAnexo();
    
          // this.beanActionPlanFiles = new BeanActionPlanFiles(null, null, null, null, null);
          }

          this.toastr.success(' Atualizado com sucesso', 'SUCESSO AO ATUALIZAR')

          this.buscarPlanosDeAcoes();
          this.clearFormulario();

        },errorResponse => {

          this.toastr.error(' Erro ao Atualizar usuario', 'ERRO AO ATUALIZAR')

        })

    }else{

      this.planoDeAcaoBean = new BeanPlanoDeAcao (
        this.formularioPlanoDeAcao.value.placIdCdPlanoacao,
        this.formularioPlanoDeAcao.value.idOperacaoMenu,
        this.formularioPlanoDeAcao.value.placDsAcao,
        this.formularioPlanoDeAcao.value.placdsobjetivo,
        this.formularioPlanoDeAcao.value.placDhDataacao,
        this.formularioPlanoDeAcao.value.placNrPrazodiasacao,
        this.formularioPlanoDeAcao.value.placDsResponsavel,
        this.formularioPlanoDeAcao.value.stacIdCdStatusacao,
        this.formularioPlanoDeAcao.value.placDsAnaliseeficacia,
        this.formularioPlanoDeAcao.value.placDsTracker,
        this.formularioPlanoDeAcao.value.placDsObservacao,
        this.idUser,
        this.formularioPlanoDeAcao.value.placDhCadastro,
        this.formularioPlanoDeAcao.value.placDhInativo == true ? '1900-01-01T00:00:00' : null,                           
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        
      );


        //CRIAR NOVO USUARIO
        this.planoDeAcaoService.addPlanoDeAcao(this.planoDeAcaoBean).then((retorno:any)=>{

          if(retorno.usuaIdCdUsuario != null && retorno.usuaIdCdUsuario > 0){

            this.planoDeAcaoBean.placIdCdPlanoacao = retorno.placIdCdPlanoacao;

              this.toastr.success(retorno.msgResponse, 'SUCESSO AO GRAVAR', {timeOut: 1000})
           
              this.planoDeAcaoBean.placIdCdPlanoacao = retorno.placIdCdPlanoacao;
/*
              if(this.beanActionPlanFiles.plaaDsArquivo != "" &&
                this.beanActionPlanFiles.placIdCdPlanoacao != "" &&
                this.beanActionPlanFiles.plaaDsNomearquivo != "" &&
                this.base64Output
              ){*/
        
                this.beanActionPlanFiles.placIdCdPlanoacao = this.planoDeAcaoBean.placIdCdPlanoacao;
                //this.salvarAnexo();
                let dialogTitle = "";
                let dialogText = "";
              
                  dialogTitle = 'Plano de ação salvo com sucesso. Deseja adicionar anexos?';
                  dialogText = 'Ação: Abrir tela de anexos.';
               
            
                const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
                  data: {
                    dialogTitle: dialogTitle,
                    dialogText: dialogText
                  }, width: '320px'
                });
            
                dialogRef.afterClosed().subscribe((result: boolean) => {
                 
                  this.buscarPlanosDeAcoes();

                  if (result){
                    this.loadDialogAnexo();
                    this.setFormPlanoDeAcao(this.planoDeAcaoBean);
                  }
                  
                  

                });
            

        
              // this.beanActionPlanFiles = new BeanActionPlanFiles(null, null, null, null, null);
             // }


              
              //this.clearFormulario();

           }else{

            this.toastr.error(retorno.msgResponse, 'ERRO AO GRAVAR')
            //this.clearFormulario();
          }
        },

          errorResponse => {
            this.toastr.error(' Erro ao gravar Usuário', 'ERRO AO GRAVAR')
            //this.clearFormulario();
        })
      }


      
      
  }






  
  public addParecer():void{
    
    if(
        this.formularioParecer.get("idOperacaoMenu").value == "" ||
        this.formularioParecer.get("meseIdCdMeses").value == ""    ||
         this.formularioParecer.get("pareNrAno").value == "" ||
        this.formularioParecer.get("pareTxParecer").value == "" 
      ){
           this.toastr.error('Preencha todos os campos obrigatórios antes de salvar', 'Obrigatoriedade')
        return
      }

     
      
        this.parecerBean = new BeanParecer (
          this.formularioParecer.value.pareIdCdParecer,
          this.formularioParecer.value.idOperacaoMenu,
          this.formularioParecer.value.meseIdCdMeses,
          this.formularioParecer.value.pareNrAno,
          this.formularioParecer.value.pareTxParecer,
          this.idUser,
          null,
          this.formularioParecer.value.isInativo == true ? '1900-01-01T00:00:00' : null,     
          null,
          null,
        );


    if(this.formularioParecer.value.pareIdCdParecer != '' && this.formularioParecer.value.pareIdCdParecer > 0){

        this.planoDeAcaoService.updateParecer(this.parecerBean).then((retorno:any)=>{

          this.toastr.success(' Atualizado com sucesso', 'SUCESSO AO ATUALIZAR')

          this.buscarParecer();
          this.clearFormularioParecer();

        },errorResponse => {

          this.toastr.error(' Erro ao Atualizar usuario', 'ERRO AO ATUALIZAR')

        })

    }else{

        //CRIAR NOVO USUARIO
        this.planoDeAcaoService.addParecer(this.parecerBean).then((retorno:any)=>{

          if(retorno.usuaIdCdUsuario != null && retorno.usuaIdCdUsuario > 0){

              this.toastr.success(retorno.msgResponse, 'SUCESSO AO GRAVAR', {timeOut: 1000})
           
              this.buscarParecer();
              this.clearFormularioParecer();

           }else{

            this.toastr.error(retorno.msgResponse, 'ERRO AO GRAVAR')
            //this.clearFormulario();
          }
        },

          errorResponse => {
            this.toastr.error(' Erro ao gravar Usuário', 'ERRO AO GRAVAR')
            //this.clearFormulario();
        })
      }


  }



  clearFormulario(){

    //limpar formulario
    this.formularioPlanoDeAcao.controls['placIdCdPlanoacao'].setValue(0);
    this.formularioPlanoDeAcao.controls['placDsAcao'].setValue("");
    this.formularioPlanoDeAcao.controls['placdsobjetivo'].setValue("");
    this.formularioPlanoDeAcao.controls['placDhDataacao'].setValue("");
    this.formularioPlanoDeAcao.controls['placNrPrazodiasacao'].setValue("");
    this.formularioPlanoDeAcao.controls['placDsResponsavel'].setValue("");
    this.formularioPlanoDeAcao.controls['stacIdCdStatusacao'].setValue("");
    this.formularioPlanoDeAcao.controls['placDsAnaliseeficacia'].setValue("");
    this.formularioPlanoDeAcao.controls['placDsTracker'].setValue("");
    this.formularioPlanoDeAcao.controls['placDsObservacao'].setValue("");
    this.formularioPlanoDeAcao.controls['placDhCadastro'].setValue("");
    
    this.formularioPlanoDeAcao.controls['nmUserupdate'].setValue("");
    this.formularioPlanoDeAcao.controls['dhUpdate'].setValue("");
    this.formularioPlanoDeAcao.controls['nmUserConcluiu'].setValue("");
    this.formularioPlanoDeAcao.controls['dhConcluiu'].setValue("");

    //limpar anexo
    this.fileName ='';
    this.contemAnexo = false;
    this.beanActionPlanFiles = new BeanActionPlanFiles(null, null, null, null, null);
    this.qtdAnexos = 0;

  }

  
  
  clearFormularioParecer(){

    //limpar
    //this.formularioPlanoDeAcao.controls['idOperacao'].setValue("");
    this.formularioParecer.controls['pareIdCdParecer'].setValue(0);
    this.formularioParecer.controls['idOperacaoMenu'].setValue("");
    this.formularioParecer.controls['meseIdCdMeses'].setValue("");
    //this.formularioParecer.controls['pareNrAno'].setValue("");
    this.formularioParecer.controls['pareTxParecer'].setValue("");
    this.formularioParecer.controls['usuaIdCdUsuario'].setValue("");
    this.formularioParecer.controls['pareDhCadastro'].setValue("");
    this.formularioParecer.controls['isInativo'].setValue("");
    
  }

 

  public listarPlanoDeAcaoPorOperacao(idOperacao : string){

    if(idOperacao != ""){

      this.planoDeAcaoService.listarPlanosDeAcoesPorOperacoes(idOperacao).then((retorno:any)=>{
          this.dataSource = new MatTableDataSource<BeanPlanoDeAcao>(retorno);

          this.dataSource.sort = this.sortUsuario; 
        },
        errorResponse => { //CASO ERRO

          this.setSessionExpired(errorResponse) ? true : this.toastr.error('Erro ao conectar Backend.\nComunique suporte sistemas.','Lista Usuários');

        }).catch((retorno:any) => {

          if(retorno.error.error_description.indexOf("Access token expired")>-1){
              alert("Sessão Expirada");
              this.router.navigate(['']);
            }
        });
      }
    }
    
    public listarParecer(){
      
        this.planoDeAcaoService.listarParecer().then((retorno:BeanParecer[])=>{

            let listaParecerNew : BeanParecer[] = [];

            let jsonObj = JSON.parse(localStorage.getItem('empresasUsuario')); // string to "any" object first
            let beanOperacao = jsonObj as BeanOperacao[];

            for(var operacao of beanOperacao){

              //retorno.filter(t=>t.operIdCdOperacao === operacao.operIdCdOperacao)[0] != undefined ? listaParecerNew.push(retorno.filter(t=>t.operIdCdOperacao === operacao.operIdCdOperacao)[0]) : 'não faz nada'  ;

              for(var ret of retorno){

                if(operacao.operIdCdOperacao == ret.operIdCdOperacao){
                  listaParecerNew.push(ret)
                }

              }
              
            }


            //ORDENAÇÃO
            this.dataSourceParecer = new MatTableDataSource<BeanParecer>(listaParecerNew);

            //ORDENAR OBJETOS DENTRO DO OBJETO RETORNADO
            this.dataSourceParecer.sortingDataAccessor = (item, property) => {
              switch(property) {
                case 'operations': return item.operations.operNmOperacao;
                case 'month': return item.month.meseIdCdMeses;
                default: return item[property];
              }
            };

            this.dataSourceParecer.sort = this.sortParecer; 
  
          },
          errorResponse => { //CASO ERRO
  
            this.setSessionExpired(errorResponse) ? true : this.toastr.error('Erro ao conectar Backend.\nComunique suporte sistemas.','Lista Usuários');
  
          }).catch((retorno:any) => {
  
            if(retorno.error.error_description.indexOf("Access token expired")>-1){
                alert("Sessão Expirada");
                this.router.navigate(['']);
              }
          });
        
      }

    public listarCmbSituacao(){

      this.planoDeAcaoService.listarSituacao().then((retorno:BeanSituacao[])=>{

        this.lstCmbSituacao = retorno;

      }, errorResponse => {

        this.setSessionExpired(errorResponse) ? true : this.toastr.error('Erro conexao backend\nContate o suporte.','COMBO PRODUTOS');

      }).catch((retorno:any) => {

        if(retorno.error.error_description.indexOf("Access token expired")>-1){
            alert("Sessão Expirada");
            this.router.navigate(['']);
          }
      });

    }



  applyFilter(event: Event) {

    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  applyFilterParecer(event: Event) {

    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSourceParecer.filter = filterValue.trim().toLowerCase();


    //FILTRAR OBJETOS DENTRO DO OBJETO PRINCIPAL
    this.dataSourceParecer.filterPredicate = (data: any, filter) => {
      const dataStr =JSON.stringify(data).toLowerCase();
      return dataStr.indexOf(filter) != -1; 
    }

  }

  setFormPlanoDeAcao(form: BeanPlanoDeAcao){

     this.clearFormulario();

      this.formularioPlanoDeAcao.controls['placIdCdPlanoacao'].setValue(form.placIdCdPlanoacao);
      this.formularioPlanoDeAcao.controls['idOperacaoMenu'].setValue(form.operIdCdOperacao);
      this.formularioPlanoDeAcao.controls['placDsAcao'].setValue(form.placDsAcao);
      this.formularioPlanoDeAcao.controls['placdsobjetivo'].setValue(form.placdsobjetivo);
      this.formularioPlanoDeAcao.controls['placDhDataacao'].setValue(form.placDhDataacao);
      this.formularioPlanoDeAcao.controls['placNrPrazodiasacao'].setValue(form.placNrPrazodiasacao);
      this.formularioPlanoDeAcao.controls['placDsResponsavel'].setValue(form.placDsResponsavel);
      this.formularioPlanoDeAcao.controls['placDhCadastro'].setValue(form.placDhCadastro);
      this.formularioPlanoDeAcao.controls['stacIdCdStatusacao'].setValue(form.stacIdCdStatusacao);
      this.formularioPlanoDeAcao.controls['placDsAnaliseeficacia'].setValue(form.placDsAnaliseeficacia);
      this.formularioPlanoDeAcao.controls['placDsTracker'].setValue(form.placDsTracker);
      this.formularioPlanoDeAcao.controls['placDsObservacao'].setValue(form.placDsObservacao);
      this.formularioPlanoDeAcao.controls['usuaIdCdUsuario'].setValue(form.usuaIdCdUsuario);


      this.formularioPlanoDeAcao.controls['nmUserupdate'].setValue(form.userUpdate?.usuaNmUsuario);
      this.formularioPlanoDeAcao.controls['dhUpdate'].setValue(form.placDhUpdate);

      this.formularioPlanoDeAcao.controls['nmUserConcluiu'].setValue(form.userConcluiu ==null ? '' : form.userConcluiu.usuaNmUsuario);
      this.formularioPlanoDeAcao.controls['dhConcluiu'].setValue(form.placDhConcluido);

      this.percentualFormulario = form.percentual;
      this.statusPlanoAcaoFormulario = form.statusPlanoAcao;

      if(form.placIdCdPlanoacao != undefined && form.placIdCdPlanoacao != ''){
        this.planoDeAcaoBean = form
        this.buscarAnexoPlanoAcao(form);
      }
      

  }

  setFormParecer(form: BeanParecer){

    if(this.validarEmpresaParecer(Number(form.operIdCdOperacao))){
  
      this.formularioParecer.controls['pareIdCdParecer'].setValue(form.pareIdCdParecer);
      this.formularioParecer.controls['idOperacaoMenu'].setValue(form.operIdCdOperacao);
      this.formularioParecer.controls['meseIdCdMeses'].setValue(form.meseIdCdMeses);
      this.formularioParecer.controls['pareNrAno'].setValue(form.pareNrAno);
      this.formularioParecer.controls['pareTxParecer'].setValue(form.pareTxParecer);
      this.formularioParecer.controls['usuaIdCdUsuario'].setValue(form.usuaIdCdUsuario);
      this.formularioParecer.controls['pareDhCadastro'].setValue(form.pareDhRegistro);
      this.formularioParecer.controls['isInativo'].setValue(form.pareDhInativo);

    }else{
      
      this.toastr.error('Seu usuário não tem acesso a empresa selecionada.','VALIDAÇÃO');
      this.clearFormularioParecer();

    }


}


validarEmpresaParecer(idOperacao : number) : boolean{

  let retorno = false;


  let jsonObj = JSON.parse(localStorage.getItem('empresasUsuario')); // string to "any" object first
  let beanOperacao = jsonObj as BeanOperacao[];
  

  for(var operacao of beanOperacao){

    if(idOperacao == Number(operacao.operIdCdOperacao)){
      retorno = true
    }
    
  }

  return retorno
}


  onClickDesligado(value: MatSlideToggleChange){
    if(!value.checked){
      this.formularioPlanoDeAcao.controls['dataDesligamento'].setValue("");
    }
  }



  
    public preencheCmbOperacao(){

      return this.cadastroUsuarioService.getUsuarioPorRe(this._AESEncryptDecryptService.decrypt(localStorage.getItem('reUser')).trim()).then((retorno:any)=>{
  
        this.lstCmbOperacao = retorno.operations;
  
      }, errorResponse => {
  
        this.setSessionExpired(errorResponse) ? true : this.toastr.error('Erro conexao backend\nContate o suporte.','COMBO OPERACOES');
  
  
      }).catch((retorno:any) => {
  
        if(retorno.error.error_description.indexOf("Access token expired")>-1){
            alert("Sessão Expirada");
            this.router.navigate(['']);
          }
      });
  
    }



  public onChangeBusca(valorSelecionado:any){

    this.formularioPlanoDeAcao.controls['formaBusca'].setValue(valorSelecionado.value);
    this.limparListas();
    this.clearFormulario();

  }

  public limparListas(){
    this.lstPlanosDeAcoes = [];    
    this.dataSource = new MatTableDataSource<BeanPlanoDeAcao>(this.lstPlanosDeAcoes);
  }

  
  public limparListasParecer(){
    this.lstParecer = [];    
    this.dataSourceParecer = new MatTableDataSource<BeanParecer>(this.lstParecer);
  }

  public buscarPlanosDeAcoes(){

    this.clearFormulario();
    this.limparListas();
    this.listarPlanoDeAcaoPorOperacao(this.formularioPlanoDeAcao.controls.idOperacaoMenu.value);

  }


  
  
  public buscarParecer(){

    this.clearFormularioParecer();
    this.limparListasParecer();
    this.listarParecer();

  }
  


  openSnackBar(idUsuario: string) {


    //ABRIR A MENSAGEM SNACKBAR
    let snack =  this._snackBar.open('Deseja editar o usuário que acabou de criar?', 'Clique aqui', {

      duration: 10000,
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
    });

    snack.onAction().subscribe(() => {

      this.limparListas();
      this.clearFormulario();

      this.planoDeAcaoService.getUsuarioPorId(Number(idUsuario)).then((beanUsuario: BeanPlanoDeAcao) => {

        this.setFormPlanoDeAcao(beanUsuario);
      }, errorResponse => {

        this.setSessionExpired(errorResponse);
      })

    });
  }


  excluirPlanoAcao(obj : BeanPlanoDeAcao ){


    let dialogTitle = "";
    let dialogText = "";
  
      dialogTitle = 'Deseja excluir o Plano de ação?';
      dialogText = 'Caso a solicitação de exclusão for confirmada, não será possível recuperar os dados.';
   

    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        dialogTitle: dialogTitle,
        dialogText: dialogText
      }, width: '320px'
    });

    dialogRef.afterClosed().subscribe((result: boolean) => {
      if (result){

        this.planoDeAcaoService.inativarPlanoAcao(obj).then((retorno:any)=>{

          this.toastr.success(' Atualizado com sucesso', 'SUCESSO AO ATUALIZAR')
    
          this.buscarPlanosDeAcoes();
          this.clearFormulario();
    
        },errorResponse => {
    
          this.toastr.error(' Erro ao Atualizar plano de ação', 'ERRO AO ATUALIZAR')
    
        })


      }
    });
    
   
    
  }


  loadDialogAnexo() {

    const dialogRef = this.dialog.open(AnexosDialogComponent, {
      width: '55%',
      data: {
        idPlanoAcao: this.planoDeAcaoBean.placIdCdPlanoacao,
        dsPlanoAcao: this.planoDeAcaoBean.placDsAcao
      }

    });



    dialogRef.afterClosed().subscribe(result => {

      if (result.sessionExpired) {

        this.sessionExpired = result.sessionExpired;
        this.resetSessionExpired();

      } else {
        this.buscarAnexoPlanoAcao(this.planoDeAcaoBean)

      }

    });

  }

  

}
